var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconZeroCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-zeroCheck"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-zeroCheck",
    clipPath: "url(#clip-icon-zeroCheck)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M689.677,961.387c-96.335,0-174.71-78.375-174.71-174.71s78.375-174.709,174.71-174.709,174.71,78.374,174.71,174.709S786.012,961.387,689.677,961.387Zm0-293.419a118.71,118.71,0,1,0,118.71,118.709A118.844,118.844,0,0,0,689.677,667.968Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M682.322,876.995a28,28,0,0,1-21.062-9.55l-51.871-59.221a28,28,0,1,1,42.125-36.9l29.68,33.885,54.24-68.774a28,28,0,1,1,43.971,34.678l-75.1,95.22a28,28,0,0,1-21.264,10.653Q682.682,876.995,682.322,876.995Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M517.419,959.839H232.613a73.082,73.082,0,0,1-73-73V137.613a73.082,73.082,0,0,1,73-73H791.387a73.083,73.083,0,0,1,73,73v479.9a28,28,0,0,1-56,0v-479.9a17.02,17.02,0,0,0-17-17H232.613a17.02,17.02,0,0,0-17,17V886.839a17.019,17.019,0,0,0,17,17H517.419a28,28,0,0,1,0,56Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M632.9,398.495q0,39.321-4.795,67.608a157.455,157.455,0,0,1-17.74,51.306q-16.307,28.292-42.2,43.633t-57.54,15.344q-36.445,0-65.331-20.617T401.79,498.708a211.861,211.861,0,0,1-10.909-43.993A365.725,365.725,0,0,1,387.4,402.57a500.681,500.681,0,0,1,3.836-65.211q3.831-29.006,11.987-49.867,14.144-34.523,41.116-52.624t64.372-18.1q24.69,0,44.833,8.032a102.3,102.3,0,0,1,35.363,23.5q15.221,15.463,25.772,38.239Q632.9,326.091,632.9,398.495ZM567.215,393.7q0-43.874-5.276-71.8T544.2,279.7q-12.469-14.261-34.524-14.264-31.645,0-43.993,31.886t-12.347,98.3q0,45.075,5.274,73.842t17.742,43.514q12.462,14.743,33.8,14.744,22.053,0,34.523-15.344t17.5-43.873Q567.212,439.971,567.215,393.7Z",
    fill: "#428b27"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZeroCheck);
export default __webpack_public_path__ + "static/media/icon-zeroCheck.3581a94651a7409a329c078fda11d0ba.svg";
export { ForwardRef as ReactComponent };